import { IncludedContacts } from './IncludedContacts';
import { IncludedUsersPreSeats } from './IncludedUsersPreSeats';
import { jsx as _jsx } from "react/jsx-runtime";
export const SubtextDisplay = ({
  additionalUnitSkuId,
  queryParamTerm,
  productLevel,
  isSeatsUser,
  skuCategoryName,
  includedWithParentProduct,
  quantityName
}) => {
  const isPreSeatsAdditionalUsers = (quantityName === 'SALES_SEAT' || quantityName === 'SERVICE_SEAT') && !isSeatsUser;
  const isAdditionalContacts = quantityName === 'CONTACTS';
  if (isPreSeatsAdditionalUsers && includedWithParentProduct) {
    return /*#__PURE__*/_jsx(IncludedUsersPreSeats, {
      productLevel: productLevel,
      includedWithParentProduct: includedWithParentProduct,
      skuCategoryName: skuCategoryName
    });
  }
  if (isAdditionalContacts && includedWithParentProduct) {
    return /*#__PURE__*/_jsx(IncludedContacts, {
      additionalUnitSkuId: additionalUnitSkuId,
      queryParamTerm: queryParamTerm,
      productLevel: productLevel,
      includedWithParentProduct: includedWithParentProduct
    });
  }
  return null;
};